module.exports = __webpack_public_path__ + "img/4.b9b93474.jpg";